import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import history from '../history';

import createRootReducers from '../modules/reducers';
import rootSagas from '../modules/sagas';

const actionStateInjectorMiddleware = (store) => (next) => (action) => {
  next({ ...action, getState: store.getState });
};

let composeEnhancers = compose;
const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
  const middlewares = [];
  middlewares.push(actionStateInjectorMiddleware);

  if (process.env.NODE_ENV === 'development') {
    middlewares.push(createLogger({ collapsed: true }));

    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }
  const store = createStore(
    createRootReducers(history),
    composeEnhancers(applyMiddleware(...middlewares, sagaMiddleware)),
  );

  sagaMiddleware.run(rootSagas);

  return {
    ...store,
  };
}
